import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { hasPermission } from "../utils/permissions";

export default function PrivateRoute({ children, requiredPermission, requireAdmin }) {
  const { user, isloading } = useContext(UserContext);
  const token = localStorage.getItem("access_token") || localStorage.getItem("token");
  
  // Attendre le chargement de l'utilisateur
  if (isloading) {
    return <div>Chargement...</div>;
  }
  
  // Si pas de token, rediriger vers login
  if (!token || !user) {
    return <Navigate to="/" />;
  }
  
  // Si admin est requis, vérifier
  if (requireAdmin && !user?.is_admin && !user?.is_superuser) {
    return <Navigate to="/dashboard" />;
  }
  
  // Si une permission est requise, vérifier
  if (requiredPermission && !hasPermission(user, requiredPermission)) {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
}

